import { ActionsCell } from '../../../Component/Common/Components/DataTable/ActionsCell';
import { DefaultCell } from '../../../Component/Common/Components/DataTable/DefaultCell';
import { ActionType, TableColumn } from '../../../Component/Model/Table/Table';
import {VerificationAgencyClient} from "../../../Component/Model/Dto/VerificationAgency/VerificationAgencyClient";
import {TableDateHelper} from "../../../Component/Model/helpers";

interface FeedbackRow{
  FeedbackId: number,
  VaClientId: number,
  CompanyName: string,
  ClientName: string,
  CreatedDate: string,
  SendDate?: string,
  ReceivedDate?: string,
  ReferenceNumber: string
  Actions: ActionType[];
}

export interface FeedbackTable {
  columns: Array<TableColumn>;
  rows: Array<FeedbackRow>;
}

export function FeedbackTableMapper(dataObject: VerificationAgencyClient.FeedbackResponseDto[], deleteFeedback: (id: number) => void, viewFeedback: (id: number) => void): FeedbackTable {
  const columns = [
    { Header: 'Feedback Reference Number', accessor: 'ReferenceNumber', Cell: ({ value }: any) => <DefaultCell  value={value} /> },
    { Header: 'Company Name', accessor: 'CompanyName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    { Header: 'Client Name and Surname', accessor: 'ClientName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    { Header: 'Date Sent', accessor: 'SendDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    { Header: 'Date Received', accessor: 'ReceivedDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
  ];
  if (dataObject && dataObject.length > 0) {
    const rows = dataObject.map((item: VerificationAgencyClient.FeedbackResponseDto, index: number) => ({
      FeedbackId: item.feedbackId,
      CompanyName: item.companyName,
      ClientName: item.clientName,
      SendDate: item.sendDate !== null ? TableDateHelper(new Date(item.sendDate).toUTCString()) : "",
      ReceivedDate: item.receivedDate !== null ? TableDateHelper(new Date(item.receivedDate).toUTCString()) : "",
      CreatedDate: TableDateHelper(new Date(item.createdDate).toUTCString()),
      ReferenceNumber: item.referenceNumber,
      VaClientId: item.vaClientId,
      Actions: [
        {
          key: index.toString(),
          label: 'View Feedback Form',
          action: () => {
            viewFeedback(item.feedbackId);
          },
          icon: {
            color: 'info',
            name: 'visibility'
          }
        },
        {
          key: index.toString(),
          label: 'Delete Feedback Form',
          action: () => {
            deleteFeedback(item.feedbackId);
          },
          icon: {
            color: 'error',
            name: 'delete'
          }
        },
      ]

    }));
    return { columns: columns, rows: rows };
  }
  else {
    return { columns: columns, rows: [] };
  }
}

